import { generatePath, useHistory } from 'react-router-dom'

import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useModals } from 'almanac-ui/Modal'
import { useWorkspaces } from 'hooks/useWorkspaces'
import { useOnboardingTracking } from 'hooks/useOnboardingTracking'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { sendToApi } from 'api/client'
import { UserService } from 'api/clients/UserService'
import { VIRTUAL_MARKETER_ONBOARDING_PATH } from 'paths'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { UPGRADED_FROM_WORKSPACE_ID } from '../VirtualMarketerPlansModal/components/CreditCardForm/CreditCardForm'
import { VirtualMarketerPreparingModal } from '../VirtualMarketerPreparingModal/VirtualMarketerPreparingModal'
import { useUpdateUserAppPreferences } from 'hooks/queries/useUpdateUserAppPreferences'

export const useCreateAutopilotWorkspace = () => {
  const { mutateAsync: updatePreferences } = useUpdateUserAppPreferences()
  const currentWorkspaceId = useCurrentWorkspaceId()
  const workspaces = useWorkspaces()
  const { openModal, closeModal, closeAllModals } = useModals()
  const { trackOnboardingWorkspaceCreated } = useOnboardingTracking()
  const history = useHistory()

  const createAutopilotWorkspace = async () => {
    openModal(VirtualMarketerPreparingModal, { showOnboardingLoader: true })

    const res = await sendToApi(`/w/${currentWorkspaceId}/virtual_marketers`, {
      method: 'POST',
    })

    if (res.type === SUCCESS_RESPONSE_TYPE) {
      localStorage.setItem(UPGRADED_FROM_WORKSPACE_ID, currentWorkspaceId.toString())

      const newWorkspace = res.data.company

      trackOnboardingWorkspaceCreated()

      await updatePreferences({ scheduledPostsView: 'calendar' })

      UserService.setWorkspaces([...workspaces, newWorkspace])
      UserService.setCurrentWorkspaceId(newWorkspace.id)

      closeAllModals()
      history.push(generatePath(VIRTUAL_MARKETER_ONBOARDING_PATH, { workspaceId: newWorkspace.id }))
    } else {
      closeModal()
      showToastMessage('An error occurred. Try again. Contact support if the issue persists.', 'error')
    }
  }

  return {
    createAutopilotWorkspace,
  }
}
